/** @format */

export const PLP_CONSTANTS: any = {
	appPathPrefix: 'f'
};
